import React from 'react';
import moment from 'moment';
import { Form, DatePicker } from 'tea-component';

import GPSelect from '@gp/components/Select';
import TinyEditor from '@gp/components/TinyEditor';
import { CONSTANT_TEXTS } from '@gp/constants/const';

import './index.scss';

const UpdateAllProjectForm = () => {
  const options01 = [
    {
      value: 'Not started',
      text: CONSTANT_TEXTS.NOT_STARTED,
    },
    { value: 'On hold', text: CONSTANT_TEXTS.ON_HOLD },
    { value: 'Completed', text: CONSTANT_TEXTS.COMPLETED },
    { value: 'Canceled', text: CONSTANT_TEXTS.CANCELED },
  ];

  return (
    <div className="dbg-all-project-edit font 14">
      <Form className="dbg-all-project-edit-form">
        <Form.Item label="Priority" className="dbg-all-project-edit-form-item">
          <GPSelect
            clearable={false}
            value={options01[1].value}
            options={options01}
            className="dbg-edit-form-source-selector"
          />
        </Form.Item>
        <Form.Item label="Official Launch Date" className="dbg-all-project-edit-form-item">
          <div className="date-picker-day">
            <div className="date-picker-day-label">DAY</div>
            <div className="date-picker-day-main">
              <DatePicker
                defaultValue={moment('2020-10-01')}
                onChange={(value) => console.log(value.format('YYYY/MM/DD'))}
                onOpenChange={(open) => console.log(open ? 'open' : 'close')}
              />
            </div>
          </div>
        </Form.Item>
        <Form.Item label="Status" className="dbg-all-project-edit-form-item">
          <GPSelect
            clearable={false}
            value={options01[1].value}
            options={options01}
            className="dbg-edit-form-source-selector"
          />
        </Form.Item>

        <Form.Item label="Roboto" className="dbg-all-project-edit-form-item">
          <div className="dbg-wang-editor-box">
            <TinyEditor
              className="project-update-card-key-updates-wang-editor gp-word-break-word"
              placeholder="Please enter information"
              status="success"
              value=""
              getEditorContent={() => {}}
              getEditorText={() => {}}
              getIsFocused={() => {}}
            />
          </div>
        </Form.Item>

        <Form.Item label="Project Updates" className="dbg-all-project-edit-form-item">
          <div className="dbg-wang-editor-box">
            <TinyEditor
              className="project-update-card-key-updates-wang-editor gp-word-break-word"
              placeholder="Please enter information"
              status="success"
              value=""
              getEditorContent={() => {}}
              getEditorText={() => {}}
              getIsFocused={() => {}}
            />
          </div>
        </Form.Item>
      </Form>
    </div>
  );
};
export default UpdateAllProjectForm;
